import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import { Paginator } from 'primereact/paginator';
import {
  fetchChainAuditLogs as _fetchChainAuditLogs,
} from '../../../actions/chainActions';
import { T, cardStyle, inputLabelStyle } from './chainSettingsV2Styles';

var ACTION_LABEL_KEYS = {
  created: 'auditActionCreated',
  updated: 'auditActionUpdated',
  deleted: 'auditActionDeleted',
  invited: 'auditActionInvited',
  edited: 'auditActionUpdated',
  api_get: 'auditActionApiGet',
  api_post: 'auditActionApiPost',
  purchase_invoice_sync: 'auditActionPurchaseInvoiceSync',
  purchase_invoice_matched: 'auditActionPurchaseInvoiceMatched',
  purchase_invoice_filtered: 'auditActionPurchaseInvoiceFiltered',
  consolidated_composed: 'auditActionConsolidatedComposed',
  consolidated_exported: 'auditActionConsolidatedExported',
  invoice_settings_updated: 'auditActionInvoiceSettingsUpdated',
  netvisor_settings_updated: 'auditActionNetvisorSettingsUpdated',
  care_service_settings_updated: 'auditActionCareServiceSettingsUpdated',
  added: 'auditActionAdded',
  removed: 'auditActionRemoved',
  workshop_assigned: 'auditActionWorkshopAssigned',
};

var CATEGORIES = [
  { key: '', label: 'auditAll' },
  { key: 'netvisor', label: 'auditNetvisor' },
  { key: 'permission', label: 'auditPermissions' },
  { key: 'care_service', label: 'auditCareService' },
  { key: 'invoice', label: 'auditInvoice' },
  { key: 'vehicle', label: 'auditVehicle' },
  { key: 'settings', label: 'auditSettings' },
];

function formatDateTime(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleString('fi-FI');
}

function getStatusStyle(status) {
  if (status === 'error') return { color: '#ef5350' };
  if (status === 'warning') return { color: '#FFA726' };
  return { color: '#A5D6A7' };
}

class SettingsChainAuditLogV2 extends React.Component {
  state = {
    category: '',
    page: 1,
    expandedId: null,
  };

  componentDidMount() {
    this.refetch();
  }

  componentDidUpdate(prevProps) {
    if (this.props.chainId && this.props.chainId !== prevProps.chainId) {
      this.refetch();
    }
  }

  refetch = function () {
    var chainId = this.props.chainId;
    if (!chainId) return;
    var params = { page: this.state.page };
    if (this.state.category) {
      params.category = this.state.category;
    }
    this.props.fetchChainAuditLogs(chainId, params);
  }.bind(this);

  changeCategory = function (category) {
    this.setState({ category: category, page: 1 }, this.refetch);
  }.bind(this);

  changePage = function (e) {
    this.setState({ page: Math.floor(e.first / (e.rows || 20)) + 1 }, this.refetch);
  }.bind(this);

  render() {
    var t = this.props.t;
    var logs = this.props.chainAuditLogs || [];
    var pagination = this.props.chainAuditLogsPagination;
    var status = this.props.chainAuditLogsStatus;
    var isLoading = status && status.loading;
    var activeCategory = this.state.category;
    var expandedId = this.state.expandedId;

    return (
      <CBMediaQuery>
        {function (screenSize) {
          return (
            <div style={{ ...cardStyle, position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <i className="pi pi-list" style={{ fontSize: 20, color: T.accent }} />
                </div>
                <div>
                  <h2 style={{ color: T.textPrimary, fontSize: 18, fontWeight: 600, margin: 0 }}>{t('auditLogTitle')}</h2>
                  <p style={{ color: T.textSecondary, fontSize: 13, margin: '4px 0 0 0' }}>{t('auditLogDescription')}</p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: 16 }}>
                {CATEGORIES.map(function (cat) {
                  var isActive = activeCategory === cat.key;
                  return (
                    <button
                      key={cat.key}
                      onClick={function () { this.changeCategory(cat.key); }.bind(this)}
                      style={{
                        padding: '5px 12px',
                        borderRadius: 16,
                        border: 'none',
                        fontSize: 12,
                        fontWeight: 600,
                        cursor: 'pointer',
                        backgroundColor: isActive ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.08)',
                        color: isActive ? '#fff' : 'rgba(255,255,255,0.6)',
                      }}
                    >
                      {t(cat.label)}
                    </button>
                  );
                }.bind(this))}
              </div>

              {isLoading && <CBSpinnerFloating color={T.accent} />}

              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={styles.th}>{t('auditTime')}</th>
                    <th style={styles.th}>{t('auditAction')}</th>
                    <th style={styles.th}>{t('auditUser')}</th>
                    <th style={styles.th}>{t('auditSummary')}</th>
                    <th style={{ ...styles.th, width: 50 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {logs.length > 0 ? logs.map(function (log) {
                    var isExpanded = expandedId === log.id;
                    return (
                      <React.Fragment key={log.id}>
                        <tr
                          style={{ ...styles.row, cursor: 'pointer' }}
                          onClick={function () {
                            this.setState({ expandedId: isExpanded ? null : log.id });
                          }.bind(this)}
                        >
                          <td style={styles.td}>{formatDateTime(log.created_at)}</td>
                          <td style={styles.td}>
                            <span style={{ ...styles.badge, ...getStatusStyle(log.status) }}>{ACTION_LABEL_KEYS[log.action] ? t(ACTION_LABEL_KEYS[log.action]) : log.action}</span>
                          </td>
                          <td style={styles.td}>{log.user_display || '-'}</td>
                          <td style={styles.td}>{log.summary || '-'}</td>
                          <td style={styles.td}>
                            <i className={isExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
                               style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12 }} />
                          </td>
                        </tr>
                        {isExpanded && log.details && Object.keys(log.details).length > 0 && (
                          <tr>
                            <td colSpan={5} style={{ padding: '8px 16px', backgroundColor: 'rgba(0,0,0,0.2)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                              <pre style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11, margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', backgroundColor: 'transparent' }}>
                                {JSON.stringify(log.details, null, 2)}
                              </pre>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  }.bind(this)) : (
                    <tr>
                      <td colSpan={5} style={{ ...styles.td, textAlign: 'center', color: 'rgba(255,255,255,0.4)' }}>
                        {t('auditNoLogs')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {pagination && pagination.count > 0 && (
                <div style={{ marginTop: 12 }}>
                  <Paginator
                    first={(pagination.page_size * (pagination.current_page - 1))}
                    rows={pagination.page_size}
                    totalRecords={pagination.count}
                    onPageChange={this.changePage}
                  />
                </div>
              )}
            </div>
          );
        }.bind(this)}
      </CBMediaQuery>
    );
  }
}

var styles = {
  th: {
    textAlign: 'left',
    fontSize: 11,
    fontWeight: 600,
    color: 'rgba(255,255,255,0.5)',
    textTransform: 'uppercase',
    padding: '8px 12px',
    borderBottom: '1px solid rgba(255,255,255,0.15)',
  },
  td: {
    padding: '8px 12px',
    fontSize: 13,
    color: '#fff',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    verticalAlign: 'top',
  },
  row: {},
  badge: {
    fontSize: 11,
    fontWeight: 600,
    fontFamily: 'monospace',
  },
};

function mapStateToProps(state) {
  return {
    chainAuditLogs: state.chain.chainAuditLogs,
    chainAuditLogsPagination: state.chain.chainAuditLogsPagination,
    chainAuditLogsStatus: state.chain.chainAuditLogsStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChainAuditLogs: _fetchChainAuditLogs,
  },
)(translate('ChainSettingsView')(SettingsChainAuditLogV2));
